<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        プリセット {{ title }}
      </template>

      <template v-slot:content>
        <v-tabs v-model="tab" color="secondary">
          <v-tab>基本情報</v-tab>
          <v-tab :disabled="isNew">コンテンツ管理</v-tab>
          <v-tab :disabled="isNew">プレビュー・公開</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-preset-form @submit="submit" :is-new="isNew" />
          </v-tab-item>
          <v-tab-item>
            <v-preset-content-manager
              :preset-content-pages="presetContentPages"
              :preset-id="presetId"
              @updated="reloadDetail"
            />
          </v-tab-item>
          <v-tab-item>
            <v-preset-preview
              :preset-id="presetId"
              :status="status"
              :has-pdf="hasPdf"
              :question-sheet-urls="questionSheetUrls"
              :answer-urls="answerUrls"
              :answer-sheet-urls="answerSheetUrls"
              @updated="reloadDetail"
            />
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VPresetForm from '@/components/organizms/PresetForm.vue'
import VPresetContentManager from '@/components/organizms/PresetContentManager.vue'
import VPresetPreview from '@/components/organizms/PresetPreview.vue'

export default {
  components: {
    VBaseCard,
    VPresetForm,
    VPresetContentManager,
    VPresetPreview,
  },

  data() {
    return {
      tab: 0,
      presetContentPages: [],
      presetDetails: [],
      questionSheetUrls: [],
      answerUrls: [],
      answerSheetUrls: [],
      status: '',
      hasPdf: false,
    }
  },

  async mounted() {
    if (!this.isNew) {
      await this.loadDetail()
    } else {
      this.$store.commit('preset/initialize')
    }
  },

  beforeDestroy() {
    this.$store.commit('preset/initialize')
  },

  computed: {
    title() {
      return this.$store.getters['preset/title']
    },
    presetId() {
      const id = this.$route.params.id
      return id === 'new' ? null : parseInt(id)
    },
    isNew() {
      return this.$route.params.id === 'new'
    },
  },

  methods: {
    async loadDetail() {
      this.$app.$refs.loading.open({ message: '読み込み中です。少々お待ちください。' })
      const res = await this.$axios(`/api/v1/admin/presets/${this.presetId}`)
      this.applyDetail(res.data)
      this.$app.$refs.loading.close()
    },
    async reloadDetail() {
      const res = await this.$axios(`/api/v1/admin/presets/${this.presetId}`)
      this.applyDetail(res.data)
    },
    applyDetail(data) {
      this.$store.commit('preset/setPreset', data)
      this.presetContentPages = data.preset_content_pages || []
      this.presetDetails = data.preset_details || []
      this.questionSheetUrls = data.question_sheet_urls || []
      this.answerUrls = data.answer_urls || []
      this.answerSheetUrls = data.answer_sheet_urls || []
      this.status = data.status || ''
      this.hasPdf = data.has_pdf || false
    },
    async submit() {
      this.$app.$refs.loading.open({ message: '処理中です。少々お待ちください。' })
      try {
        const validation = await this.$store.dispatch('preset/validate')
        if (validation.status === 'error') {
          this.$toasted.global.error({ message: validation.message })
          this.$app.$refs.loading.close()
          return
        }
        const res = await this.$store.dispatch('preset/submit')
        this.$toasted.global.success({ message: res.message })
        if (this.isNew && res.data && res.data.id) {
          this.$router.replace(`/admin/preset/${res.data.id}`)
          this.applyDetail(res.data)
        } else {
          await this.reloadDetail()
        }
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.messages
          ? e.response.data.messages
          : '保存に失敗しました'
        this.$toasted.global.error({ message: message })
      }
      this.$app.$refs.loading.close()
    },
  }
}
</script>

<style lang="stylus" scoped>
.select
  font-size: 11px !important;
</style>
